<template>
    <div class="video-dialog">
        <el-dialog :visible.sync="dialogVisible" width="700" destroy-on-close>
            <video :src="videoUrl" class="video-full" muted autoplay :controls="true">
            </video>
        </el-dialog>
    </div>

</template>

<script>
export default {
    data(){
        return{
           videoUrl:'',
           dialogVisible:false,

        }
    },
    methods:{
    open(url) {
        this.videoUrl = url
         this.dialogVisible = true
    }
    }
}
</script>

<style scoped>
.video-full {
    width: 100%;
    display: block;
}


.video-dialog /deep/ .el-dialog__body {
    padding: 0 !important;
}

.video-dialog /deep/ .el-dialog__header {
    padding: 0 !important;


}
</style>